const LOGISTIC_SEARCH_TERM = "LOGISTIC_SEARCH_TERM";

const logisticSearchTermAction = (data) => {
  return {
    type: LOGISTIC_SEARCH_TERM,
    data,
  };
};

const logisticSearchTerm = (data) => {
  return (dispatch) => {
    dispatch(logisticSearchTermAction(data));
  };
};

const SET_LOGISTIC_GROUPS = "SET_LOGISTIC_GROUPS";

const setLogisticGroupsAction = (data) => {
  return {
    type: SET_LOGISTIC_GROUPS,
    data,
  };
};

const setLogisticGroups = (data) => {
  return (dispatch) => {
    dispatch(setLogisticGroupsAction(data));
  };
};

export { LOGISTIC_SEARCH_TERM, logisticSearchTerm, SET_LOGISTIC_GROUPS, setLogisticGroups };
